<template>
  <div id="modal" @click.self="clickOutside">
    <div
      v-if="isMounted"
      class="modal-container"
      ref="innerModal"
      :style="{...modalStyle, backgroundColor: getBackgroundColor}"
    >
      <component
        :class="{scaledUp: isScaledUp}"
        :salesPopupType="component.salesPopupType"
        v-bind:is="component.bind.is"
        v-bind="component.bind"
        v-on="component.on"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalComponent',
  components: {},
  props: {
    component: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: '50%',
    },
    height: {
      type: String,
      required: false,
    },
    overflow: {
      type: String,
      required: false,
    },
  },
  computed: {
    getBackgroundColor() {
      return this.component.backgroundColor || 'white';
    },
    isScaledUp() {
      return this.component.isScaledUp;
    },
  },
  data() {
    return {
      modalStyle: {
        width: this.component.width,
        height: this.component.height || 'unset',
        overflow: this.component.overflow || 'hidden',
      },
      upperPicture: null,
      isMounted: false,
    };
  },
  mounted() {
    this.isMounted = true;
    this.upperPicture = this.component.upperPicture;
  },
  methods: {
    clickOutside() {
      if (this.component.bind.closeable) {
        this.$eventBus.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#modal {
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  z-index: z("modal");
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  .modal-container {
    max-width: 100vw;
    max-height: 100vh;
    transition: all 1s ease-in-out;
    z-index: 20;
    overflow: hidden;
    @include center(both);
    border-radius: 8px;
  }
}
</style>
